module.exports = __webpack_public_path__ + "static/demo1-15be1a39925cf8a16fa772bc48f05969.mp4";